import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Button } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckAuthorization from "../../utilities/auth/checkAuthorization";
import Loader from "../loader";
import {
  getNielsenBookmarks,
  setBookmarksNielsen,
  setNielsenBookmarkLoader,
  getEposBookmarks,
  setBookmarksEpos,
  setEposBookmarkLoader,
} from "../../slicers/bookmarks.slicer";
import {
  setEmailAddressNielsen,
  setNielsenBookmarkData,
  setnielsencolumnSelectionCheckbox,
  setNielsenCustFilters,
  setNielsenWeeklyCustFilters,
  setNielsenProdFilters,
  setnielsenTimeframeCheckbox,
  setNielsenTimeHorizonRadio,
  setNielsenYear,
  setNielsenYearPeriod,
  setNielsenYearPeriodWeek,
  setTimeSelectedDynamicWeeklyNielsen,
  setDatasetNielsen,
  getNielsenCustomerFilters,
  getNielsenProductFilters,
  getNielsenKPIs,
} from "../../slicers/nielsenfilters.slicer";
import {
  getEposFilters,
  setEmailAddressEpos,
  setEposBookmarkData,
  seteposcolumnSelectionCheckbox,
  setEposFilters,
  seteposTimeframeCheckbox,
  setEposTimeHorizonRadio,
  setEposYear,
  setEposYearPeriod,
  setEposYearPeriodWeek,
  setTimeSelectedfromDynamicWeekly,
  setDatasetEpos,
  getEposKPIs,
} from "../../slicers/eposfilters.slicer";
import CustomAxios from "../../utilities/service/api.service";
import { API } from "../../utilities/constants";
import { showErrorMessage } from "../../utilities/helperFns";

const Bookmarks = ({ bookmarkOn, hideBookmark, dataset }) => {
  const dispatch = useDispatch();
  const {
    bookmarksNielsen,
    nielsen_bookmark_loader,
    bookmarksEpos,
    epos_bookmark_loader,
  } = useSelector((state) => state.bookmarks);
  const {
    cust_filters_nielsen,
    prod_filters_nielsen,
    nielsenYear,
    nielsenYearPeriod,
    nielsenYearPeriodWeek,
    nielsentimeframeCheckbox,
    timeHorizonRadioNielsen,
    nielsen_columnSelectionCheckbox,
    nielsen_dataset_selected,
    email_address_nielsen,
  } = useSelector((state) => state.nielsenfilters);
  const {
    filters_epos,
    eposYear,
    eposYearPeriod,
    eposYearPeriodWeek,
    epostimeframeCheckbox,
    timeHorizonRadioEpos,
    eposcolumnSelectionCheckbox,
    epos_dataset_selected,
    epos_email_address,
  } = useSelector((state) => state.eposfilters);
  const [applyError, setApplyError] = useState(false);
  const [newBookmark, setNewBookmark] = useState(false);
  const [name, setName] = useState("");
  const [key, setKey] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  //function to show success message in toast after saving bookmark
  const showSaveSuccessMessage = () => {
    toast.success("Bookmark Saved!", {
      position: toast.POSITION.TOP_CENTER,
      className: "toast-message",
    });
  };
  //function to show success message in toast after deleting bookmark
  const showDeletedSuccessMessage = () => {
    toast.success("Bookmark Deleted!", {
      position: toast.POSITION.TOP_CENTER,
      className: "toast-message",
    });
  };
  //function to show error message in toast while saving bookmark with an existing name
  const showErrorSaving = () => {
    toast.error(
      "A bookmark already exists with same name! Please enter a different name",
      {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-message",
      }
    );
  };
  //function to save nielsen bookmark in database
  const saveNielsenBookmark = (saved_bookmark) => (dispatch, getState) => {
    dispatch(setNielsenBookmarkLoader(true));
    let bookmark_data = saved_bookmark;
    CustomAxios(API.save_bookmark, "POST", bookmark_data)
      .then((response) => {
        if (response.status === 200) {
          showSaveSuccessMessage();
          dispatch(getNielsenBookmarks("nielsen"));
        }
      })
      .catch((err) => {
        if (
          err.response.status === 400 &&
          err.response.data.error.includes("Cannot insert duplicate key")
        ) {
          showErrorSaving();
        } else if (err.status === 403) {
          CheckAuthorization();
          showErrorMessage();
        } else {
          showErrorMessage();
        }
      })
      .finally(() => {
        dispatch(setNielsenBookmarkLoader(false));
      });
  };
  //function to save epos bookmark in database
  const saveEposBookmark = (saved_bookmark) => (dispatch, getState) => {
    dispatch(setEposBookmarkLoader(true));
    let bookmark_data = saved_bookmark;
    CustomAxios(API.save_bookmark, "POST", bookmark_data)
      .then((response) => {
        if (response.status === 200) {
          showSaveSuccessMessage();
          dispatch(getEposBookmarks("epos"));
        }
      })
      .catch((err) => {
        if (
          err.response.status === 400 &&
          err.response.data.error.includes("Cannot insert duplicate key")
        ) {
          showErrorSaving();
        } else if (err.status === 403) {
          CheckAuthorization();
          showErrorMessage();
        } else {
          showErrorMessage();
        }
      })
      .finally(() => {
        dispatch(setEposBookmarkLoader(false));
      });
  };
  //main function for saving bookmark
  const handleSaveBookmark = (e) => {
    if (dataset === "nielsen") {
      setNewBookmark(false);
      dispatch(
        setNielsenBookmarkData({
          name: name,
          cust_filters: {
            ...cust_filters_nielsen,
          },
          prod_filters: {
            ...prod_filters_nielsen,
          },
          timeframe: nielsentimeframeCheckbox,
          col_selection: nielsen_columnSelectionCheckbox,
          dataset: nielsen_dataset_selected,
          timeHorizon: timeHorizonRadioNielsen,
          year: nielsenYear,
          year_period: nielsenYearPeriod,
          year_period_week: nielsenYearPeriodWeek,
          email: email_address_nielsen,
        })
      );
      const newbookmark = {
        name: name,
        cust_filters: {
          ...cust_filters_nielsen,
        },
        prod_filters: {
          ...prod_filters_nielsen,
        },
        timeframe: nielsentimeframeCheckbox,
        col_selection: nielsen_columnSelectionCheckbox,
        dataset: nielsen_dataset_selected,
        timeHorizon: timeHorizonRadioNielsen,
        year: nielsenYear,
        year_period: nielsenYearPeriod,
        year_period_week: nielsenYearPeriodWeek,
        email: email_address_nielsen,
      };
      dispatch(saveNielsenBookmark(newbookmark));
      setKey(key + 1);
      setName("");
    } else {
      setNewBookmark(false);
      dispatch(
        setEposBookmarkData({
          name: name,
          filters: { ...filters_epos },
          timeframe: epostimeframeCheckbox,
          col_selection: eposcolumnSelectionCheckbox,
          dataset: epos_dataset_selected,
          timeHorizon: timeHorizonRadioEpos,
          year: eposYear,
          year_period: eposYearPeriod,
          year_period_week: eposYearPeriodWeek,
          email: epos_email_address,
        })
      );
      const newbookmark = {
        name: name,
        filters: { ...filters_epos },
        timeframe: epostimeframeCheckbox,
        col_selection: eposcolumnSelectionCheckbox,
        dataset: epos_dataset_selected,
        timeHorizon: timeHorizonRadioEpos,
        year: eposYear,
        year_period: eposYearPeriod,
        year_period_week: eposYearPeriodWeek,
        email: epos_email_address,
      };
      dispatch(saveEposBookmark(newbookmark));
      setKey(key + 1);
      setName("");
    }
  };

  //function for handling discard, to discard bookmark without saving
  const handleDiscard = (id) => {
    setNewBookmark(false);
    setName("");
  };
  //function to generate a new instance of bookmark
  const CreateBookmark = () => {
    setApplyError(false);
    setNewBookmark(true);
  };
  //main function for Apply button
  const applyTheBookmark = (data) => {
    if (dataset === "nielsen") {
      let payload = data;
      dispatch(setNielsenCustFilters(payload.cust_filters));
      dispatch(setNielsenWeeklyCustFilters(payload.cust_filters));
      dispatch(setNielsenProdFilters(payload.prod_filters));
      dispatch(setnielsenTimeframeCheckbox(payload.timeframe));
      dispatch(setnielsencolumnSelectionCheckbox(payload.col_selection));
      dispatch(setEmailAddressNielsen(payload.email));
      dispatch(setNielsenTimeHorizonRadio(payload.timeHorizon));
      dispatch(setNielsenYear(payload.year));
      dispatch(setNielsenYearPeriod(payload.year_period));
      dispatch(setNielsenYearPeriodWeek(payload.year_period_week));
      let timePeriodvalue = [
        ...payload.year,
        ...payload.year_period,
        ...payload.year_period_week,
      ];
      dispatch(setTimeSelectedDynamicWeeklyNielsen(timePeriodvalue));
      dispatch(setDatasetNielsen("nielsen"));
      dispatch(getNielsenCustomerFilters(payload.cust_filters));
      dispatch(getNielsenProductFilters(payload.prod_filters));
      dispatch(getNielsenKPIs(payload.prod_filters));
      dispatch(getEposKPIs());
      hideBookmark();
    } else {
      let payload = data;
      dispatch(setEposFilters(payload.filters));
      dispatch(seteposTimeframeCheckbox(payload.timeframe));
      dispatch(seteposcolumnSelectionCheckbox(payload.col_selection));
      dispatch(setEmailAddressEpos(payload.email));
      dispatch(setEposTimeHorizonRadio(payload.timeHorizon));
      dispatch(setEposYear(payload.year));
      dispatch(setEposYearPeriod(payload.year_period));
      dispatch(setEposYearPeriodWeek(payload.year_period_week));
      let timePeriodvalue = [
        ...payload.year,
        ...payload.year_period,
        ...payload.year_period_week,
      ];
      dispatch(setTimeSelectedfromDynamicWeekly(timePeriodvalue));
      dispatch(setDatasetEpos("epos"));
      dispatch(getEposFilters(payload.filters));
      dispatch(getEposKPIs());
      hideBookmark();
    }
  };
  //function to delete bookmark from database
  const deleteABookmark = (key) => {
    if (dataset === "nielsen") {
      dispatch(setNielsenBookmarkLoader(true));
      let pk = key;
      CustomAxios(API.delete_bookmark + "?pk=" + pk, "DELETE")
        .then((response) => {
          let updatedList = [...bookmarksNielsen].filter(
            (item) => item.pk !== pk
          );
          dispatch(setBookmarksNielsen(updatedList));
          if (response.status === 200) {
            showDeletedSuccessMessage();
          }
        })
        .catch((err) => {
          if (err.status === 403) {
            CheckAuthorization();
          }
          showErrorMessage();
        })
        .finally(() => {
          dispatch(setNielsenBookmarkLoader(false));
        });
    } else {
      dispatch(setEposBookmarkLoader(true));
      let pk = key;
      CustomAxios(API.delete_bookmark + "?pk=" + pk, "DELETE")
        .then((response) => {
          let updatedList = [...bookmarksEpos].filter((item) => item.pk !== pk);
          dispatch(setBookmarksEpos(updatedList));
          if (response.status === 200) {
            showDeletedSuccessMessage();
          }
        })
        .catch((err) => {
          if (err.status === 403) {
            CheckAuthorization();
          }
          showErrorMessage();
        })
        .finally(() => {
          dispatch(setEposBookmarkLoader(false));
        });
    }
  };
  //function for displaying list of bookmarks
  const DisplayBookmarks = ({ bookmarksList, loader }) => {
    if (bookmarksList.length !== 0) {
      return (
        <Loader loading={loader} tip={"Please Wait..."}>
          <div className="bookmark-content">
            <ul className="bookmark-list">
              {bookmarksList
                .filter((value) => {
                  if (
                    searchValue === "" ||
                    value.payload.name
                      .toLowerCase()
                      .includes(searchValue.toLowerCase())
                  ) {
                    return value;
                  }
                })
                .map((item) => (
                  <Col className="bookmark-col">
                    <li className="bookmark-list-item" key={item.pk}>
                      <span className="bookmark-field-name">
                        {item.payload.name}
                      </span>
                    </li>
                    <Button
                      className="apply-button"
                      type="primary"
                      onClick={() => applyTheBookmark(item.payload)}
                    >
                      Apply
                    </Button>
                    <Button
                      className="delete-button"
                      type="primary"
                      onClick={() => deleteABookmark(item.pk)}
                    >
                      Delete
                    </Button>
                    <ToastContainer />
                  </Col>
                ))}
            </ul>
          </div>
        </Loader>
      );
    } else {
      return (
        <div className="bookmark-display">
          <div className="bookmark-content">
            <p>Create A Bookmark</p>
          </div>
        </div>
      );
    }
  };
  return (
    <>
      <div className="add-search-bookmark">
        <input
          type="text"
          className="search-box"
          onChange={(e) => setSearchValue(e.target.value)}
          value={searchValue}
          placeholder="Search by name"
        />
        <Button
          className="add-button"
          type="primary"
          onClick={() => CreateBookmark()}
        >
          Add a Bookmark
        </Button>
      </div>
      <div className="bookmark-display">
        {newBookmark === true ? (
          <div className="bookmark-input-warning">
            <div className="bookmark-input">
              <input
                type="text"
                placeholder="Enter name of bookmark"
                className="input-field"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
              <Button
                className="save-button"
                type="primary"
                onClick={() => {
                  name.length !== 0
                    ? handleSaveBookmark()
                    : setApplyError(true);
                }}
              >
                Save
              </Button>
              <Button
                className="discard-button"
                type="primary"
                onClick={() => handleDiscard()}
              >
                Discard
              </Button>
              <ToastContainer />
            </div>
            {applyError === true ? (
              <span className="error-indication">
                Field should not be empty
              </span>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {dataset === "nielsen" ? (
          <DisplayBookmarks
            bookmarksList={bookmarksNielsen}
            loader={nielsen_bookmark_loader}
          />
        ) : (
          <DisplayBookmarks
            bookmarksList={bookmarksEpos}
            loader={epos_bookmark_loader}
          />
        )}
      </div>
    </>
  );
};

export default Bookmarks;
